export default "__VITE_ASSET__KjAWgEnJ__"